import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { selectSelectedProduct } from '../../redux/selectors/productSelector';
import { useDispatch, useSelector } from 'react-redux';
import { addItemToCart } from '../../redux/slices/cartSlice';
import { toggleWishlistItem } from '../../redux/slices/wishlistSlice';
import { selectIsProductInWishlist } from '../../redux/selectors/wishlistSelector';
import { toggleCompareItem } from '../../redux/slices/compareSlice';
import { selectIsProductInCompare } from '../../redux/selectors/compareSelector';
import { updatePrice } from '../../utils/helper';
import Button from '../../components/Button';

import avatarImg1 from '../../assets/img/testimonial/avatar-1.png';
import avatarImg2 from '../../assets/img/testimonial/avatar-2.png';

const ShopDetailsArea = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [quantity, setQuantity] = useState(1); // Local state for handling quantity input
  const dispatch = useDispatch();

  const selectedProduct = useSelector(selectSelectedProduct); // selector to get product details
  const productId = selectedProduct?.productId; //Initialize productId
  const isInWishlist = useSelector((state) =>
    selectIsProductInWishlist(state, productId)
  ); // selector to check if the product is in Wishlist
  const isProductInCompare = useSelector(selectIsProductInCompare(productId)); // selector to check if the product is in compare
  const isNew = selectedProduct?.badgeTitle?.toLowerCase() === 'new'; // Define isNew based on badgeTitle
  const calculatedPrice = updatePrice(selectedProduct);

  //Reset quantity to 1 when component mount and product changes
  useEffect(() => {
    setQuantity(1);
  }, [productId]);

  // Handler to add product to cart with the selected quantity
  const handleAddToCart = () => {
    dispatch(
      addItemToCart({
        product: {
          ...selectedProduct,
          id: productId,
          thumbnail: selectedProduct.thumbnailImg,
        },
        quantity,
      })
    );
    setQuantity(1);
  };

  // handler to increment quantity
  const handleIncrement = () => {
    setQuantity((prev) => prev + 1);
  };

  // handler to Decrement quantity
  const handleDecrement = () => {
    setQuantity((prev) => (prev > 1 ? prev - 1 : 1));
  };

  //For handling image tab click
  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  // Dispatch the action to toggle the item to the wishlist with the adjusted price
  const handleToggleWishlist = (product) => {
    dispatch(
      toggleWishlistItem({
        ...product,
        thumbnail: product.images[0],
        id: product.productId,
      })
    );
  };

  // Dispatch the action to toggle the item to the wishlist with the adjusted price
  const handleToggleCompare = (product) => {
    dispatch(
      toggleCompareItem({
        ...product,
        thumbnail: product.images[0],
        id: product.productId,
      })
    );
  };

  // Tab names for react tabs
  const tabNames = [
    { tabName: 'Description' },
    { tabName: 'Additional Information' },
    { tabName: 'Reviews (02)' },
  ];
  const tabStyle =
    'nav nav-tabs pro-details-nav-btn justify-content-center justify-content-between';

  return (
    <div className="it-shop-details__area pt-120 pb-120">
      <div className="container">
        <div className="it-shop-details__top-wrap mb-120">
          <div className="row">
            <div className="col-xl-6 col-lg-6">
              <div className="it-shop-details__wrapper">
                <div className="it-shop-details__tab-content-box mb-20">
                  <div className="tab-content">
                    {selectedProduct?.images.map(
                      (image, index) =>
                        activeTab === index && (
                          <div
                            key={index}
                            className="it-shop-details__tab-big-img"
                          >
                            <img src={image} alt="" />
                          </div>
                        )
                    )}
                  </div>
                </div>
                <div className="it-shop-details__tab-btn-box">
                  <div className="nav nav-tab justify-content-center">
                    {selectedProduct?.images.map((image, index) => (
                      <button
                        key={index}
                        type="button"
                        className={activeTab === index ? 'active' : ''}
                        onClick={() => handleTabClick(index)}
                      >
                        <img src={image} alt="" />
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6">
              <div className="it-shop-details__right-wrap">
                <h3 className="it-shop-details__title-sm mb-30">
                  {selectedProduct?.title}
                </h3>
                <div className="it-shop-details__price d-flex align-items-center">
                  {!isNew && (
                    <del>${Math.round(selectedProduct?.price).toFixed(2)} </del>
                  )}
                  <span>
                    $
                    {isNew
                      ? selectedProduct?.price.toFixed(2)
                      : Math.round(calculatedPrice).toFixed(2)}
                  </span>
                  <div className="it-shop-details__ratting">
                    <i className="flaticon-star"></i>
                    <span>(25 Customer reviews)</span>
                  </div>
                </div>
                <div className="it-shop-details__quantity-wrap">
                  <div className="it-shop-details__quantity-box d-flex align-items-center mb-30">
                    <div className="it-shop-details__quantity">
                      <div
                        className="cart-minus"
                        onClick={() => handleDecrement()}
                      >
                        <i className="fal fa-minus"></i>
                      </div>
                      <input
                        type="text"
                        id="quantity"
                        min="1"
                        value={quantity} // Always use local state `quantity`
                        readOnly
                      />
                      <div
                        className="cart-plus"
                        onClick={() => handleIncrement()}
                      >
                        <i className="fal fa-plus"></i>
                      </div>
                    </div>
                    <div className="it-shop-details__btn">
                      <Link
                        className="it-btn-theme text-white"
                        to="#"
                        onClick={() => handleAddToCart()}
                      >
                        <Button btnText="Add To Cart" />
                      </Link>
                    </div>
                  </div>
                  <div className="it-shop-details__text pb-10">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod <br /> tempor incididunt ut labore et
                      dolore magna aliqua. Ut enim ad minim <br /> veniam, quis
                      nostrud exercitation ullamco laboris
                    </p>
                  </div>
                  <div className="it-shop-details__icon mb-40 ">
                    <Link
                      to="#"
                      className={isInWishlist ? 'active' : ''}
                      onClick={() => handleToggleWishlist(selectedProduct)}
                    >
                      <i
                        className={
                          isInWishlist
                            ? 'fa-solid fa-heart'
                            : 'fa-light fa-heart'
                        }
                      ></i>
                    </Link>
                    <Link
                      to="#"
                      className={isProductInCompare ? 'active' : ''}
                      onClick={() => handleToggleCompare(selectedProduct)}
                    >
                      <i className="fa-sharp fa-light fa-arrows-repeat"></i>
                    </Link>
                  </div>
                  <div className="it-shop-details__Category pb-35">
                    <span>
                      <i>SKU:</i> medical kit-12
                    </span>
                    <span>
                      <i>Categories: </i> {selectedProduct?.category}
                    </span>
                  </div>

                  <div className="it-shop-details__social">
                    <a href="#">
                      <i className="flaticon-facebook-app-symbol"></i>
                    </a>
                    <a href="#">
                      <i className="flaticon-twitter-1"></i>
                    </a>
                    <a href="#">
                      <i className="flaticon-pinterest"></i>
                    </a>
                    <a href="#">
                      <i className="flaticon-instagram"></i>
                    </a>
                    <a href="#">
                      <i className="flaticon-linkedin-1"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="productdetails-tabs">
            <div className="row">
              <div className="col-xl-12 col-lg-12 col-12">
                <Tabs>
                  <div className="product-additional-tab">
                    <div className="pro-details-nav theme-bg-2 mb-40">
                      <TabList className={tabStyle}>
                        {tabNames.map((item, index) => (
                          <Tab key={index}>
                            <button>
                              <span>{item.tabName}</span>
                            </button>
                          </Tab>
                        ))}
                      </TabList>
                    </div>
                    <div className="tab-content it-content-tab">
                      <TabPanel>
                        <p className="mb-25">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua. Tempor nec feugiat nisl pretium
                          fusce id. Nulla facilisi etiam dignissim diam.
                          Venenatis urna cursus eget nunc scelerisque viverra
                          mauris in aliquam. Volutpat ac tinciduntvitae semper
                          quis lectus. Dolor morbi non arcu risus quis varius
                          quam quisque id. Cras tincidunt lobortis feugiat
                          vivamus at augue. Lacinia at quis risus sed vulputate
                          odio ut. Mauris nunc congue nisi vitae suscipit.
                          Consectetur adipiscing elit pellentesque habitant
                          morbi. Egestas egestas fringilla phasellus faucibus
                          scelerisque eleifend donec. Enim blandit volutpat
                          maecenas volutpat blandit aliquam etiam erat velit.
                          Condimentum mattispellentesque id nibh tortor id
                          aliquet
                        </p>
                        <p className="mb-0">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua. Ut enim ad minim veniam, quis
                          nostrud exercitation ullamco laboris nisi ut aliquip
                          ex ea commodo consequat. Duis aute irure dolor in
                          reprehenderit in voluptate velit esse cillum dolore eu
                          fugiat nulla pariatur. Excepteur sint occaecat
                          cupidatat non proident, sunt in culpa qui officia
                          deserunt mollit anim id est laborum.
                        </p>
                      </TabPanel>
                      <TabPanel>
                        <div className="product__details-info table-responsive">
                          <table className="table table-striped">
                            <tbody>
                              <tr>
                                <td className="add-info">Weight</td>
                                <td className="add-info-list"> 2 lbs</td>
                              </tr>
                              <tr>
                                <td className="add-info">Dimensions</td>
                                <td className="add-info-list">
                                  12 × 16 × 19 in
                                </td>
                              </tr>
                              <tr>
                                <td className="add-info">Product</td>
                                <td className="add-info-list">
                                  Purchase this product on rag-bone.com
                                </td>
                              </tr>
                              <tr>
                                <td className="add-info">Color</td>
                                <td className="add-info-list">Gray, Black</td>
                              </tr>
                              <tr>
                                <td className="add-info">Size</td>
                                <td className="add-info-list">S, M, L, XL</td>
                              </tr>
                              <tr>
                                <td className="add-info">Model</td>
                                <td className="add-info-list"> Model </td>
                              </tr>
                              <tr>
                                <td className="add-info">Shipping</td>
                                <td className="add-info-list">
                                  Standard shipping: $5,95L
                                </td>
                              </tr>
                              <tr>
                                <td className="add-info">Care Info</td>
                                <td className="add-info-list">
                                  Machine Wash up to 40ºC/86ºF Gentle Cycle
                                </td>
                              </tr>
                              <tr>
                                <td className="add-info">Brand</td>
                                <td className="add-info-list"> Kazen</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </TabPanel>
                      <TabPanel>
                        <div className="product-details-review">
                          <h3 className="it-comments-title mb-35">
                            02 reviews for “Wide Cotton Tunic extreme hammer”
                          </h3>
                          <div className="latest-comments mb-55">
                            <ul>
                              <li>
                                <div className="comments-box d-flex">
                                  <div className="comments-avatar mr-25">
                                    <img src={avatarImg1} alt="" />
                                  </div>
                                  <div className="comments-text">
                                    <div className="comments-top d-sm-flex align-items-start justify-content-between mb-5">
                                      <div className="avatar-name">
                                        <b>Kenneth M. Fulford</b>
                                        <div className="comments-date mb-20">
                                          <span>May 11, 202 7:05 am</span>
                                        </div>
                                      </div>
                                      <div className="user-rating">
                                        <ul>
                                          <li>
                                            <a href="#">
                                              <i className="fas fa-star"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="#">
                                              <i className="fas fa-star"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="#">
                                              <i className="fas fa-star"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="#">
                                              <i className="fas fa-star"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="#">
                                              <i className="fal fa-star"></i>
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                    <p className="m-0">
                                      Lorem ipsum dolor sit amet, consectetur
                                      adipiscing elit. Curabitur vulputate
                                      vestibulum Phasellus rhoncus, dolor eget
                                      viverra pretium, dolor tellus aliquet
                                      nunc, vitae ultricies erat elit eu lacus.
                                      Vestibulum non justo consectetur, cursus
                                      ante, tincidunt sapien. Nulla quis diam
                                      sit amet turpis interdum accumsan quis nec
                                      enim. Vivamus faucibus ex sed nibh egestas
                                      elementum. Mauris et bibendum dui. Aenean
                                      consequat pulvinar luctus. Suspendisse
                                      consectetur tristique tortor
                                    </p>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div className="comments-box d-flex">
                                  <div className="comments-avatar mr-25">
                                    <img src={avatarImg2} alt="" />
                                  </div>
                                  <div className="comments-text">
                                    <div className="comments-top d-sm-flex align-items-start justify-content-between mb-5">
                                      <div className="avatar-name">
                                        <b>Martha S. Gorman</b>
                                        <div className="comments-date mb-20">
                                          <span>March 07, 2022 10:35 am</span>
                                        </div>
                                      </div>
                                      <div className="user-rating">
                                        <ul>
                                          <li>
                                            <a href="#">
                                              <i className="fas fa-star"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="#">
                                              <i className="fas fa-star"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="#">
                                              <i className="fas fa-star"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="#">
                                              <i className="fas fa-star"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="#">
                                              <i className="fal fa-star"></i>
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                    <p className="m-0">
                                      We have covered many special events such
                                      as fireworks, fairs, parades, races,
                                      walks, awards ceremonies, fashion shows,
                                      sporting events, and even a memorial
                                      service. Lorem ipsum dolor sit amet,
                                      consectetur adipiscing elit. Curabitur
                                      vulputate vestibulum Phasellus rhoncus,
                                      dolor eget viverra pretium, dolor tellus
                                      aliquet nunc, vitae ultricies erat elit eu
                                      lacus. Vestibulum non justo consectetur,
                                      cursus ante, tincidunt sapien. Nulla quis
                                      diam sit amet turpis interdum accumsan
                                      quis nec enim. Vivamus faucibus ex sed
                                      nibh egestas elementum. Mauris et bibendum
                                      dui. Aenean consequat pulvinar luctus.
                                      Suspendisse consectetur
                                    </p>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <div className="product-details-comment">
                            <div className="comment-title mb-20">
                              <h3>Add a review</h3>
                              <p>
                                Your email address will not be published.
                                Required fields are marked*
                              </p>
                            </div>
                            <div className="comment-rating mb-20 d-flex">
                              <span>Overall ratings</span>
                              <ul>
                                <li>
                                  <a href="#">
                                    <i className="fas fa-star"></i>
                                  </a>
                                </li>
                                <li>
                                  <a href="#">
                                    <i className="fas fa-star"></i>
                                  </a>
                                </li>
                                <li>
                                  <a href="#">
                                    <i className="fas fa-star"></i>
                                  </a>
                                </li>
                                <li>
                                  <a href="#">
                                    <i className="fas fa-star"></i>
                                  </a>
                                </li>
                                <li>
                                  <a href="#">
                                    <i className="fal fa-star"></i>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <div className="comment-input-box">
                              <form action="#">
                                <div className="row">
                                  <div className="col-xxl-12">
                                    <div className="comment-input">
                                      <textarea placeholder="Your review..."></textarea>
                                    </div>
                                  </div>
                                  <div className="col-xxl-6">
                                    <div className="comment-input">
                                      <input
                                        type="text"
                                        placeholder="Your Name*"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-xxl-6">
                                    <div className="comment-input">
                                      <input
                                        type="email"
                                        placeholder="Your Email*"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-xxl-12">
                                    <div className="comment-submit">
                                      <button className="it-btn-theme">
                                        <Button btnText="Submit" />
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </TabPanel>
                    </div>
                  </div>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShopDetailsArea;
